import { call, put, takeLatest } from 'redux-saga/effects';
import invokeApi from '../network';
import networkConfig from '../network/config';
import { GENERATE_CLIENT_TOKEN, GENERATE_CLIENT_TOKEN_SUCCESS, GENERATE_CLIENT_TOKEN_FAILURE, TRANSACTION_SALE, TRANSACTION_SALE_FAILURE, TRANSACTION_SALE_SUCCESS, TRANSACTION_SUBMIT, TRANSACTION_SUBMIT_FAILURE, TRANSACTION_SUBMIT_SUCCESS, TRANSACTION_VOID, TRANSACTION_VOID_FAILURE, TRANSACTION_VOID_SUCCESS, } from '../constants';
import { setErrorCode } from '../redux/Actions/ErrorAction';
export function* generateClientTokenCall(request) {
    try {
        const { payload, successCallback, errorCallback } = request;
        const { tenantId, customerId, data } = payload;
        const headers = {
            'x-tenant-id': tenantId,
            // 'x-is-registered-user': true, // Due to API blocked by CORS policy
            // 'x-user-id': customerId, // Due to API blocked by CORS policy
        };
        const { response, status } = yield call(invokeApi, networkConfig.generateClientTokenForBraintree, null, headers, data);
        if (status >= 400) {
            yield put(setErrorCode(status));
        }
        if (response && status === 200) {
            yield put({
                type: GENERATE_CLIENT_TOKEN_SUCCESS,
                response,
            });
            successCallback && successCallback(response);
        }
        else {
            yield put({
                type: GENERATE_CLIENT_TOKEN_FAILURE,
            });
            errorCallback && errorCallback();
        }
    }
    catch (error) {
        yield put({
            type: GENERATE_CLIENT_TOKEN_FAILURE,
        });
    }
}
export function* generateClientTokenSaga() {
    yield takeLatest(GENERATE_CLIENT_TOKEN, generateClientTokenCall);
}
export function* transactionSaleCall(request) {
    try {
        const { payload, successCallback, errorCallback } = request;
        const { tenantId, customerId, postBody } = payload;
        const headers = {
            'x-tenant-id': tenantId,
            'x-is-registered-user': true,
            'x-user-id': customerId,
        };
        const { response, status } = yield call(invokeApi, networkConfig.transactionSale, null, headers, postBody);
        if (status >= 400) {
            yield put(setErrorCode(status));
        }
        if (response) {
            yield put({
                type: TRANSACTION_SALE_SUCCESS,
                response,
            });
            successCallback && successCallback(response);
        }
        else {
            yield put({
                type: TRANSACTION_SALE_FAILURE,
            });
            errorCallback && errorCallback();
        }
    }
    catch (error) {
        yield put({
            type: TRANSACTION_SALE_FAILURE,
        });
    }
}
export function* transactionSaleSaga() {
    yield takeLatest(TRANSACTION_SALE, transactionSaleCall);
}
export function* transactionSubmitCall(request) {
    try {
        const { payload, errorCallback, successCallback } = request;
        const { tenantId, transactionId, customerId } = payload;
        const headers = {
            'x-tenant-id': tenantId,
            'x-is-registered-user': true,
            'x-user-id': customerId,
        };
        const { response, status } = yield call(invokeApi, networkConfig.transactionSubmit, { queryProps: { transactionId } }, headers);
        if (status >= 400) {
            yield put(setErrorCode(status));
        }
        if (response) {
            yield put({
                type: TRANSACTION_SUBMIT_SUCCESS,
                response,
            });
            successCallback && successCallback(response);
        }
        else {
            yield put({
                type: TRANSACTION_SUBMIT_FAILURE,
            });
            errorCallback && errorCallback();
        }
    }
    catch (error) {
        yield put({
            type: TRANSACTION_SUBMIT_FAILURE,
        });
    }
}
export function* transactionSubmitSaga() {
    yield takeLatest(TRANSACTION_SUBMIT, transactionSubmitCall);
}
export function* transactionVoidCall(request) {
    try {
        const { payload, successCallback, errorCallback } = request;
        const { tenantId, transactionId, customerId } = payload;
        const headers = {
            'x-tenant-id': tenantId,
            'x-is-registered-user': true,
            'x-user-id': customerId,
        };
        const { response, status } = yield call(invokeApi, networkConfig.transactionVoid, { queryProps: { transactionId } }, headers);
        if (status >= 400) {
            yield put(setErrorCode(status));
        }
        if (response) {
            yield put({
                type: TRANSACTION_VOID_SUCCESS,
                response,
            });
            successCallback && successCallback(response);
        }
        else {
            yield put({
                type: TRANSACTION_VOID_FAILURE,
            });
            errorCallback && errorCallback();
        }
    }
    catch (error) {
        yield put({
            type: TRANSACTION_VOID_FAILURE,
        });
    }
}
export function* transactionVoidSaga() {
    yield takeLatest(TRANSACTION_VOID, transactionVoidCall);
}
